// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.mediacredits.RentalManagerMediaCreditsWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerMediaCreditsWebApiHandler_getMediaCredits,
  RentalManagerMediaCreditsWebApiHandler_getMediaCredits_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type { CustomerAnalyticsMediaCreditPackageDto } from '@zg-rentals/ts-rental-manager-api-client';

export type RentalManagerMediaCreditsWebApiHandler_getMediaCredits_Options = UseQueryOptions<
  CustomerAnalyticsMediaCreditPackageDto,
  unknown,
  CustomerAnalyticsMediaCreditPackageDto,
  readonly [string]
>;

const RentalManagerMediaCreditsWebApiHandler_getMediaCredits_GetKey = () =>
  [RentalManagerMediaCreditsWebApiHandler_getMediaCredits_Path] as const;

export const RentalManagerMediaCreditsWebApiHandler_getMediaCredits_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerMediaCreditsWebApiHandler_getMediaCredits_GetKey(),
    queryFn: () => RentalManagerMediaCreditsWebApiHandler_getMediaCredits(httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get media credit packages for the logged-in user's account
 */
export const useRentalManagerMediaCreditsWebApiHandler_getMediaCredits = ({
  httpClient,
  ...options
}: Omit<RentalManagerMediaCreditsWebApiHandler_getMediaCredits_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...RentalManagerMediaCreditsWebApiHandler_getMediaCredits_queryOptions({ httpClient }),
    ...options,
  });
};
useRentalManagerMediaCreditsWebApiHandler_getMediaCredits.getKey =
  RentalManagerMediaCreditsWebApiHandler_getMediaCredits_GetKey;
